{
  "title": "Redeem Code",
  "label": "Enter your voucher code",
  "placeholder": "e.g. SPECIAL-PROMO",
  "button": "Redeem Access",
  "info": "If you have a voucher code from a promotion or event, enter it above to unlock premium access.",
  "success_title": "Success",
  "success_message": "Voucher redeemed successfully!",
  "error_empty": "Please enter a voucher code.",
  "error_invalid_code": "This voucher code is not valid. Please check the code and try again.",
  "error_expired_code": "This voucher code has expired and can no longer be used.",
  "error_already_redeemed": "This voucher code has already been redeemed.",
  "error_network": "Unable to reach the server. Please check your connection and try again.",
  "error_unknown": "Something went wrong while redeeming your code. Please try again later."
}
